import React from 'react';

import Button from 'components/Button';

import './styles.css';

const Buttons = ({closeModal, terminateTenancy, submitting}) => (
  <div className="Buttons">
    <Button onClick={closeModal} transparent white className="cancel">
      Cancel
    </Button>
    <Button
      onClick={terminateTenancy}
      blue
      className="submit"
      isLoading={submitting}
      disabled={submitting}>
      Terminate Tenancy
    </Button>
  </div>
);

export default Buttons;
